var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditGreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M9.48326 4.10001L10.1588 2.93001C10.6147 2.14024 11.6246 1.86964 12.4144 2.32562V2.32562C13.2042 2.78159 13.4747 3.79147 13.0188 4.58124L12.3433 5.75124M9.48326 4.10001L5.5865 10.8494C4.89211 12.0521 4.49701 13.4233 4.43623 14.8107V14.8107C4.41173 15.37 5.01793 15.7442 5.49886 15.4577V15.4577C6.73863 14.7191 7.76843 13.6751 8.48998 12.4253L12.3433 5.75124M9.48326 4.10001L12.3433 5.75124",
    stroke: "#82993C",
    strokeWidth: 1.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-green.b889d71d9c558c5c9e65cf4968b3385f.svg";